import { Pipe, PipeTransform } from '@angular/core';
import { formatDateTime, ModeType } from '../utility/date-utils';

@Pipe({ name: 'dateTimeFormat' })
export class DateTimeFormatPipe implements PipeTransform {
  transform(date: Date, mode: ModeType = 'datetime') {
    return formatDateTime(date, mode);
  }
}
